import React, { useContext, useRef, useState } from 'react';

import { default as t } from '../../../utils/i18n';
import './link-accounts.scss';
import { UserContext } from '../../../context';
import { Banner, Button, Input, OTPInput } from '../../atoms';
import { DashboardHeader } from '../../atoms';
import { DashContentFooter } from '../../molecules';
import { useHistory } from 'react-router-dom';
import { AuthService } from '../../../services';
const bannerInitiateState = {
  show: false,
  isError: false,
  message: '',
};

const LinkAccounts = props => {
  const { user } = useContext(UserContext);
  const history = useHistory();
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const [emailIds, setEmailIds] = useState('');
  const [attempted, setAttempted] = useState(1);
  const [validationError, setValidationError] = useState(null);
  const [disableButton, setDisableButton] = useState(true);
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);

  const [banner, setBanner] = useState(bannerInitiateState);
  const bannerTimeout = useRef(null);
  const updateBanner = banner => {
    setBanner(banner);
    if (banner.show && !banner.disableTimeout) {
      clearBanner();
    }
  };

  const resetBanner = () => {
    setBanner(bannerInitiateState);
  };

  const clearBanner = () => {
    bannerTimeout.current = setTimeout(() => {
      updateBanner({ show: false, isError: false, message: '' });
    }, 7000);
  };
  const handleChange = e => {
    e.preventDefault();
    const { name, value } = e.target;
    if (name === 'email') setEmailIds(value.trim());
  };

  const handleOTPChange = otpValue => {
    if (otpValue) {
      setOtp(otpValue);
      setValidationError(null);
    }

    if (otpValue.toString().length === 6) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  };

  const sendOTP = async () => {
    try {
      const payload = {
        accountToLink: emailIds,
      };
      const otpResponse = await AuthService.sendOtp(payload, userAccessToken, username);
      if (otpResponse?.data?.data) {
        if (otpResponse?.data?.data?.message === 'OTP sent to users email to link') {
          setOtpSent(true);
        } else {
          updateBanner({
            show: true,
            isError: true,
            message: otpResponse?.data?.data?.message,
          });
        }
      }
    } catch (error) {
      console.log(error);
      updateBanner({
        show: true,
        isError: true,
        message: error?.data?.data?.message,
      });
    }
  };
  const verifyOTP = async () => {
    try {
      const payload = {
        accountToLink: emailIds,
        otp: otp,
      };
      const otpResponse = await AuthService.verifyOTP(emailIds, otp, userAccessToken, username);
      if (otpResponse?.data?.data) {
        setOtpSent(false);
        setEmailIds('');
        updateBanner({
          show: true,
          isError: false,
          message: t('link.accounts.successful'),
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const skipNow = () => {
    history.push('/interstitial');
  };

  return (
    <>
      <DashboardHeader />
      <main className="main link-acounts">
        <div className="top-section">
          <div className="user-name">
            {t('link.accounts.hello')}, {user?.name},<p>({username})</p>
          </div>
          <div className="title">{t('link.accounts.heading')}</div>
          <p className="disc">
            {otpSent ? t('link.accounts.after.otp.text') : t('link.accounts.before.otp.text')}
          </p>
        </div>
        <div className="border-line" />
        <div className="main-section">
          <Banner banner={banner} resetBanner={resetBanner} />

          {!otpSent ? (
            <div className="input-section">
              <div className="input-container">
                <Input
                  labelValue={t('user.input.label.emailAddress')}
                  emailToolTip={t('user.input.tooltip.emailAddress')}
                  name="email"
                  fieldType="email"
                  placeholder={t('link.accounts.enter.email')}
                  value={emailIds}
                  handleChange={handleChange}
                  // errorMessage={emailValidationError}
                />
                <p className="note">*{t('link.accounts.email.note')}</p>
              </div>
              <div className="button-section">
                <div className="button-container">
                  <Button
                    type="submit"
                    name="submit"
                    label={t('link.accounts.send.otp')}
                    className="send-otp"
                    disabled={!emailIds?.length}
                    handleClick={sendOTP}
                  />
                </div>
                <div className="button-container">
                  <Button
                    type="submit"
                    name="submit"
                    label={t('link.accounts.skip.now')}
                    className="skip-now"
                    outlinedButton={true}
                    handleClick={skipNow}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="otp-section">
              <div className="otp-container">
                <p className="email" title={emailIds}>
                  {emailIds}
                </p>
                <div>
                  <p className="enter-otp">{t('link.accounts.enter.otp')}</p>
                  <p className="resend-section">
                    {t('link.accounts.didnot.receive')} ?
                    <span className="resend-link"> {t('link.accounts.resend')}</span>
                  </p>
                </div>
                <div className="action-section">
                  <div className="input-container">
                    <OTPInput
                      autoFocus
                      name="otp"
                      length={6}
                      attempted={attempted}
                      onChangeOTP={handleOTPChange}
                      errorMessage={validationError}
                      //   disabled={disableOtpInput}
                    />
                  </div>
                  <div className="btn-container">
                    <Button
                      type="submit"
                      name="submit"
                      className="link-button"
                      label={t('link.account')}
                      disabled={disableButton}
                      handleClick={verifyOTP}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>
      <DashContentFooter />
    </>
  );
};

export default LinkAccounts;
